import React from 'react';
import type { IconProps } from '@mc/design-system';
/* istanbul ignore file */
// Two elements required: merging these styles onto one element makes currentColor in background resolve against its own color, rendering the glyph invisible.
const FILLED_STYLE: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  background: 'var(--cert-icon-circle, currentColor)'
};
const FILLED_INNER: React.CSSProperties = {
  display: 'flex',
  width: '64%',
  height: '64%',
  color: 'var(--cert-icon-fg, var(--c-beige-100, #FEFAF2))'
};
function IconAtWork({
  srText,
  size = 'md',
  className = '',
  filled,
  ...props
}: IconProps & {
  filled?: boolean;
}) {
  const sizeClassName = `mc-icon mc-icon--${size} ${className}`;
  const newClassName = filled ? '' : sizeClassName;
  const svg = <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 64 64" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="m35.324 50.297 1.584-3.053h7.362q.375 0 .555-.18.18-.179.18-.538v-21.63q0-.36-.18-.539-.18-.196-.555-.196h-6.024v-3.053h6.824q1.404 0 2.188.866.8.85.8 2.35v22.773q0 1.486-.8 2.335-.784.865-2.188.865zm2.922-19.018v-3.2h3.755q.474 0 .474.473v2.253q0 .474-.474.474zm0 5.338v-3.2h3.755q.474 0 .474.49v2.22q0 .49-.474.49zm0 5.338V38.74h3.755q.474 0 .474.506v2.22q0 .49-.474.49zm-18.969 8.342q-1.404 0-2.204-.865-.783-.849-.783-2.335V16.603q0-1.485.783-2.351.8-.865 2.204-.865h17.386q1.388 0 2.171.865.8.865.8 2.35v30.495q0 1.486-.8 2.335-.783.865-2.171.865zm.8-3.053h15.77q.36 0 .538-.18.195-.179.196-.538V17.174q0-.36-.196-.539-.18-.196-.538-.196h-15.77q-.36 0-.555.196-.18.18-.18.54v29.351q0 .36.18.539.196.18.555.18m3.134-22.316q-.587 0-.587-.62v-2.84q0-.62.587-.62h2.922q.604 0 .604.62v2.84q.001.62-.604.62zm6.563 0q-.604 0-.604-.62v-2.84q0-.62.604-.62h2.922q.604 0 .604.62v2.84q0 .62-.604.62zm-6.563 5.877q-.587 0-.587-.62V27.36q0-.62.587-.62h2.922q.604 0 .604.62v2.824q.001.62-.604.62zm6.563 0q-.604 0-.604-.62V27.36q0-.62.604-.62h2.922q.604 0 .604.62v2.824q0 .62-.604.62zm-6.563 5.877q-.587 0-.587-.62v-2.824q0-.62.587-.62h2.922q.604 0 .604.62v2.824q.001.62-.604.62zm6.563 0q-.604 0-.604-.62v-2.824q0-.62.604-.62h2.922q.604 0 .604.62v2.824q0 .62-.604.62zm-6.53 12.048v-5.714q0-.93.44-1.404.44-.49 1.34-.49h5.893q.897 0 1.338.49.441.474.441 1.404v5.714h-2.35v-4.881q0-.441-.458-.441h-3.853q-.44 0-.44.44v4.882z" /></svg>;
  if (filled) {
    return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<span className={sizeClassName} style={FILLED_STYLE}><span style={FILLED_INNER}>{React.cloneElement(svg, {
            style: {
              width: '100%',
              height: '100%',
              ...props.style
            }
          })}</span></span></>;
  }
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}{svg}</>;
}
export default IconAtWork;